
jQuery(document).ready(function($){

	var menu_items_count = $('#navbar-submenu > .navbar-item').length;

	// ================================================================================================
	// Wrap all tables with mobile classes
	// ================================================================================================
	// $( "table" ).wrap( "<div class='swish'></div>" );

	// ================================================================================================
	// Toggle for Executive Team Bios
	// ================================================================================================
	$('.bio-toggle').on('click',function(e){
		e.preventDefault();
		$toggle = $(this).data('toggle');
		$label = $(this).children('.label').html();
		$label = $label=="Read more"? "Read less" : "Read more";
		$(this).closest('.bio-outer').toggleClass('bg-teal-lighter');
		$(this).children('.label').html($label);
		$(this).children('div').toggleClass('ico-plus');
		$(this).children('div').toggleClass('ico-minus');
		$('#extra-'+$toggle).toggleClass('hidden');
		$('#helip-'+$toggle).toggleClass('hidden');
	});

	// ================================================================================================
	// clearsearch
	// ================================================================================================
	$('body').on('click','.clear-search',function(e){
		e.preventDefault();
		$('#q').val('');
		// alternatively clear the next input
		$(this).next('input').val('');		
		$('.clear-search').addClass('hidden');			
	});
	$('body').on('keyup','#q',function(e){
		if($('#q').val().length>0){
			$('.clear-search').removeClass('hidden');
		}else{
			$('.clear-search').addClass('hidden');			
		}
	});
	if(typeof($('#q'))!='undefined'){
		$('.clear-search').removeClass('hidden');
	}
	
	// ================================================================================================
	// Prevent double form submissions
	// ================================================================================================
    $('button[type="submit"]').on('click', function(event){
        var $button = $(this);

        // Disable the button
        setTimeout(function(){
	        $button.prop('disabled', true);
        }, 1);

        // Set a timeout to re-enable the button after 5 seconds
        setTimeout(function(){
            $button.prop('disabled', false);
        }, 30000);
    });	

	// ================================================================================================
	// highlight scrollings navs
	// ================================================================================================

	function navHighlight() {
		if($('.media-scroller').length){
			var scrollTop = $(document).scrollTop();
			var active = 0;
			var i =0;
			var navpos = $('.media-scroller-container').position();
			var navh = $('.media-scroller-container').length? $('.media-scroller-container').height() : 0;
			// console.log(navh);

			if((navpos.top - scrollTop) ==0){
				$('.media-scroller-container').addClass('shadow-lg bg-grey-lightest').removeClass('bg-white');
			}else{
				$('.media-scroller-container').removeClass('shadow-lg bg-grey-lightest').addClass('bg-white');
			}
			$('.media-block').each(function () {
				var xPos = $(this).position();
				var sectionPos = xPos.top;
				var sectionHeight = $(this).height();
				var overall = scrollTop + sectionHeight;

				if ((scrollTop + 180 + navh) >= sectionPos && scrollTop < overall) {
					$('.media-block').removeClass("SectionActives "); // border border-red
					$(this).addClass("SectionActive "); // border border-red
					active = i+1 ;
				}

				var xIndex = $(".SectionActive").index();
				var accIndex = xIndex + 1;

				i++;
			});
			if(active>0){

				$(".media-scroller li > a").addClass("font-light").removeClass("font-semibold");
				$(".media-scroller li:nth-child(" + active + ") > a").addClass("font-semibold").removeClass("font-light");
			}
		}
	}

	$(document).scroll(function () {
		navHighlight();
	});

	$('body').on('click','.scrollto',function(e){
		e.preventDefault();
		var navh = $('.media-scroller-container').length? $('.media-scroller-container').height() : 0;
		// console.log(navh);
		window.scrollTo({
			top: $('#'+$(this).data('media')).offset().top -(80+navh),
			behavior: 'smooth'
		});

	});


	// ================================================================================================
	// Toggle navigation
	// ================================================================================================


	/*
	function checksubmenuaccessability() {

		var nav_width = $('#navbar-submenu').width();
		var items = $('#navbar-submenu > .navbar-item');
		var widths = 0;
		var cutoff = menu_items_count;

		items.each( function(index, item) {
			widths += $(item).width(); 

			if ( widths < nav_width ) {
				cutoff = index;
			}
		});

		// The items will wrap
		console.log('items in menu:' + items.length);
		console.log('cutoff:' + cutoff);

		if ( cutoff == menu_items_count) {
			$('#submenu-more').hide();
			console.log("all items fit");
		} else {
			
		}
		if ( cutoff < menu_items_count ) {
			$('#submenu-more').show();
			$('#navbar-submenu > .navbar-item').not('#submenu-more').last().appendTo($('.navbar-submenu-overflow'));
			$('#submenu-more').show();
			console.log("moving item to submenu");
		} else {
			$('.navbar-submenu-overflow > div').last().appendTo($('#navbar-submenu'));
			$('#submenu-more').appendTo($('#navbar-submenu'));
			console.log("moving item back to main menu");
		}
	}
	*/

		  
	$('#submenu-more').click(function(){
		$('.navbar-submenu-overflow').slideToggle(); 
	});

	$('.navbar').on('click', '.navbar-burger', function( event ) {
	  event.preventDefault();

	  var $main_nav = $('#navbar-menu');
	  
	  if ($(this).hasClass('is-active')) {
		// Do things on Nav Close
		$main_nav.removeClass('is-active');
		$(this).removeClass('is-active');
	  } else {
		// Do things on Nav Open
		$main_nav.addClass('is-active');
		$(this).addClass('is-active');
	  }
	});

	$('.navbar').on('click', '.subnavbar-dropdown', function( event ) {
	  event.preventDefault();

	  console.log('subnavbar-dropdown');

	  var $main_nav = $('#navbar-menu');
	  var $sub_nav = $('#navbar-submenu');
	  
	  if ($(this).hasClass('is-active')) {
		// Do things on Nav Close
		$main_nav.removeClass('is-active');
		$sub_nav.removeClass('is-active');
		$(this).removeClass('is-active');
	  } else {
		// Do things on Nav Open
		$main_nav.addClass('is-active');
		$sub_nav.addClass('is-active');
		$(this).addClass('is-active');
	  }
	});

	$('.navbar').on('click', '#navbar-menu > div > .navbar-item.has-submenu > a', function( event ) {

		var lastWidth = $(window).width();

		if ( lastWidth <= 768 ) {
			event.preventDefault();

			console.log('#navbar-menu > div > .navbar-item.has-submenu > a');

			var activeclass = $(this).data("active-class");
			var parent = $(this).prev("a");

			if ( parent.length > 0 ) {
				parent.toggleClass(activeclass);
			}
			  
			$(this).parent().toggleClass('is-active');
			$(this).toggleClass('is-active');
		}
		
	});

	$('.navbar-submenu').on('click', '.has-submenu > a', function( event ) {

		var windowWidth = $(window).width();

		if ( windowWidth <= 768 ) {
		  event.preventDefault();

		  console.log('.has-submenu > a');

		  var activeclass = $(this).data("active-class");
		  var parent = $(this).prev("a");

		  if ( parent.length > 0 ) {
			//parent.toggleClass(activeclass);
		  }
		  
		  $(this).parent().toggleClass('is-active');
		  $(this).toggleClass('is-active');
		}
		
	});

	$('.navbar-submenu').on('touchstart', '.has-submenu > a', function(event) {

		console.log('touchstart .has-submenu');

		var windowWidth = $(window).width();

		if ( $(this).hasClass('submenu-open') || $(this).closest('.has-submenu.submenu-open').length > 0 ) {
			// just follow link

			console.log('here');

		} else if ( windowWidth > 768 ) {
			event.preventDefault();

			// remove any other open menus
			if ( $('.submenu-open').length > 0 ) {
				$('.submenu-open').removeClass('submenu-open');
				$(this).parent().removeClass('is-active');
				$(this).removeClass('is-active');
			}

			// open menus
			$(this).parent().addClass('is-active');
			$(this).addClass('is-active');
			$(this).parent().addClass('submenu-open');
		}
		
	});

	
	// Track resize event to see if 2nd level menu items need to be hidden in a dropdown
	//$(window).resize(function() {
	//	checksubmenuaccessability();
	//});

	$(document).click(function(event) { 

		console.log('close submenu');
		if(!$(event.target).closest('.has-submenu.submenu-open').length) {

		   if ( $('.submenu-open').length > 0) {
				$('.submenu-open').removeClass('submenu-open');
			}
		} 
	});


  
  //el.addEventListener("touchstart", handleStart, false);
  //el.addEventListener("touchend", handleEnd, false);
  //el.addEventListener("touchcancel", handleCancel, false);
  //el.addEventListener("touchmove", handleMove, false);

	// ================================================================================================
	// Attatch carousels
	// ================================================================================================
	
	function attachCarousels() {
		if ($.fn.slick) {
			// Carousels for all screens
			$('.carousel').each(function(){
				var $carousel = $(this);

				if (!$carousel.hasClass('slick-initialized')) {
					$carousel.slick({
						dots: true,
						infinite: true,
						speed: 500,
						slidesToShow: 1,
						adaptiveHeight: true,
						rows: 0,
						customPaging: function(slider, i) {
							var title = $(slider.$slides[i]).data('title');
							return '<a>' + title + '</a>';
						}
					});

					// Custom code to add a title above the navigation
					$dots = $carousel.find('.slick-dots');

					if ( typeof($carousel.data('title')) !== 'undefined' && $dots.length > 0) {
						$('<p class="slick-title">' + $carousel.data('title') + '</p>').insertBefore($dots);
					}
				}
			});

			// Carousels for all screens
			$('.quote-carousel').each(function(){
				var $carousel = $(this);

				if (!$carousel.hasClass('slick-initialized')) {
					$carousel.slick({
						dots: true,
						infinite: true,
						speed: 500,
						slidesToShow: 1,
						adaptiveHeight: true,
						rows: 0
					});
				}
			});

			// Carousels for all screens
			$('.entries-carousel').each(function(){
				var $carousel = $(this);

				if (!$carousel.hasClass('slick-initialized')) {
					$carousel.slick({
						slidesToShow: 3,
						slidesToScroll: 1,
						dots: true,
						prevArrow: '<div class="button-hover-area button-hover-area-prev"></div><button type="button" class="slick-prev">Previous</button><button type="button" class="slick-prev slick-prev-additional">Previous</button>',
						nextArrow: '<div class="button-hover-area button-hover-area-next"></div><button type="button" class="slick-next">Next</button><button type="button" class="slick-next slick-next-additional">Next</button>',
						infinite: true,
						speed: 500,
						adaptiveHeight: true,
						rows: 0,
						responsive: [
						    {
						      breakpoint: 1200,
						      settings: {
						        slidesToShow: 2,
						        slidesToScroll: 1
						      }
						    },
						    {
						      breakpoint: 768,
						      settings: {
						        slidesToShow: 1,
						        slidesToScroll: 1
						      }
						    }
					    ]
					});
/*
					$carousel.on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
						var cls = 'slick-new-active';
						$( '.slick-active').siblings().removeClass( cls );
					});

					$carousel.on( 'afterChange', function( event, slick, currentSlide, nextSlide ) {

						var cls = 'slick-new-active';

						setTimeout(function() {
							$( '.slick-active' ).addClass( cls );
						}, 10 );
							
					});
*/
					$carousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
					    var 
					        direction,
					        slideCountZeroBased = slick.slideCount - 1;

					    var slidetoshow = slick.options.slidesToShow;

					    


					    if (nextSlide == currentSlide) {
					        direction = "same";

					    } else if (Math.abs(nextSlide - currentSlide) == 1) {
					        direction = (nextSlide - currentSlide > 0) ? "right" : "left";

					    } else {
					        direction = (nextSlide - currentSlide > 0) ? "left" : "right";
					    }

					   

					    // Add a temp CSS class for the slide animation (.slick-current-clone-animate)
					    if (direction == 'right') {
					    	for (var i = 1; i <= slidetoshow; i++) {
					    		//console.log('slides',nextSlide + slideCountZeroBased + i);
					       		$('.slick-cloned[data-slick-index="' + (nextSlide + slideCountZeroBased + i) + '"]', $carousel).addClass('slick-current-clone-animate');
					       	}
					    }

					    if (direction == 'left') {
					    	for (var i = -1; i < slidetoshow-1; i++) {
					    		
					    		//console.log('slides',nextSlide - slideCountZeroBased + i);

					        	$('.slick-slide[data-slick-index="' + (nextSlide - slideCountZeroBased + i) + '"]', $carousel).addClass('slick-current-clone-animate');
					        }
					    }
					});

					$carousel.on('afterChange', function (event, slick, currentSlide, nextSlide) {
					    $('.slick-current-clone-animate', $carousel).removeClass('slick-current-clone-animate');
					    $('.slick-current-clone-animate', $carousel).removeClass('slick-current-clone-animate');
					});
				}
			});
		}
		
	}

	attachCarousels();

	// ================================================================================================
	// Toggle media types on media page
	// ================================================================================================


	$('.media-switcher').on('click',function(e){
		e.preventDefault();
		$('.media-switcher').removeClass('font-semibold');	
		$('.media-switcher').addClass('font-light');	
		$(this).removeClass('font-light');	
		$(this).addClass('font-semibold');	
		$media = $(this).data('media');
		if($media != ''){
			$('.media-block').hide();
			$('#'+$media).show();
		}else{
			$('.media-block').show();			
		}
	});


	// ================================================================================================
	// Toggle product types on product pages
	// ================================================================================================
	
	// $('.js-products-switcher').on('click',function(e){
	// 	e.preventDefault();
	// 	var $product = 'hello';
	// 	$('.js-products-switch').each(function(){
	// 		console.log($product);
	// 	});
	// 	$('.js-products-switcher').removeClass('font-semibold products-switcher-on');	
	// 	$('.js-products-switcher').addClass('font-light');	
	// 	$(this).removeClass('font-light');	
	// 	$(this).addClass('font-semibold products-switcher-on');	
	// 	var $product = $(this).data('product');
	// 	if($product != ''){
	// 		$('.js-products-switch').removeClass('hidden');
	// 		$('.js-products-switch').each(function(){
	// 			var $hidethese = $(this).data('product-hide').split(' ');
	// 			if(jQuery.inArray($product, $hidethese) !== -1){
	// 				$(this).addClass('hidden');					
	// 			}
	// 		});
	// 	}else{
	// 		$('.js-products-switch').removeClass('hidden');
	// 	}
	// });	


	// ================================================================================================
	// Toggle product types on product pages - V 2.0 !
	// ================================================================================================


	$('.js-products-switcher').on('click',function(e){
		e.preventDefault();
		var $product = 'hello';
		$('.js-products-switch').each(function(){
			console.log($product);
		});
		$('.js-products-switcher').removeClass('font-semibold products-switcher-on');	
		$('.js-products-switcher').addClass('font-light');	
		$(this).removeClass('font-light');	
		$(this).addClass('font-semibold products-switcher-on');	
		var $product = $(this).data('product');
		if($product != ''){
			$('.js-products-switch').removeClass('hidden');
			$('.js-products-switch').each(function(){
				var $hidethese = $(this).data('product-hide').split(' ');
				if(jQuery.inArray($product, $hidethese) !== -1){
					$(this).addClass('hidden');					
				}
			});
		}else{
			$('.js-products-switch').removeClass('hidden');
		}
	});	
	
	// main filter
	$('body').on('change','select.js-filter-products',function(e){
		var $filter = $(this).val();
		window.filter=$filter;
		doProductsFilter($filter);
	});	
	$('body').on('click','a.js-filter-products',function(e){
		e.preventDefault();
		var $filter = $(this).data('filter');
		var $onClass = $(this).data('on');
		window.filter=$filter;
		$('a.js-filter-products').removeClass($onClass);
		$(this).addClass($onClass);
		doProductsFilter($filter);
	});	

	// secondary filter
	$('body').on('click','a.js-filter-products-secondary',function(e){
		e.preventDefault();
		var $subfilter = '';
		var $filter = '';
		$('.js-filter-products-secondary').removeClass('font-semibold products-switcher-on');	
		$('.js-filter-products-secondary').addClass('font-light');	
		$(this).removeClass('font-light');	
		$(this).addClass('font-semibold products-switcher-on');	
		window.subfilter = $(this).data('filter');
		// $('.js-filter-products-secondary').each(function(){
		// 	if($(this).prop('checked')){
				// window.subfilter = $(this).data('filter');
		// 	}
		// });
		if(typeof(window.filter)!='undefined'){
			$filter = window.filter;
		}
		doProductsFilter($filter);
	});

	// third filter
	$('body').on('click','a.js-filter-products-third',function(e){
		e.preventDefault();
		var $subfilter = '';
		var $filter = '';
		$('.js-filter-products-third').removeClass('font-semibold products-switcher-on');	
		$('.js-filter-products-third').addClass('font-light');	
		$(this).removeClass('font-light');	
		$(this).addClass('font-semibold products-switcher-on');	
		window.subsubfilter = $(this).data('filter');
		if(typeof(window.filter)!='undefined'){
			$filter = window.filter;
		}
		// console.log(window.filter);
		// console.log(window.subfilter);
		// console.log(window.subsubfilter);
		doProductsFilter($filter);
	});


	function doProductsFilter($filter){
		
		var $subfilter='';
		var $subsubfilter='';

		if(typeof(window.subfilter)!='undefined'){
			$subfilter = window.subfilter;
		}
		if(typeof(window.subsubfilter)!='undefined'){
			$subsubfilter = window.subsubfilter;
		}		
		// alert($filter+':'+$subfilter);

		$('.link-action.toggle-apply.active').trigger('click');
		$('.js-product-expanded').show();		

		if($filter.length){
			$filter = '.js-cat-'+$filter;			
		}
		if($filter.length && $subfilter.length){
			$filter = $filter+'.js-cat-'+$subfilter;
		}else if($subfilter.length){
			$filter = '.js-cat-'+$subfilter;			
		}
		if($subsubfilter.length){
			$filter = $filter+'.js-cat-'+$subsubfilter;			
		}

		console.log('filter:'+$filter);
		$('.js-no-results').hide();

		$('.js-wrap').fadeTo(200,0.5,function(){

			if($filter.length){
				$('.js-product').hide();
				$('.js-product-expanded').hide();
				$('.js-subhead').hide();
				$('.js-table-container').hide();
				$('.js-undertable').hide();			

				$('.js-product'+$filter).closest('.js-table-container').show();
				// THIS DOESN'T WORK
				// $('.js-subhead'+$filter).show();
				$('.js-product'+$filter).show();
				$('.js-product-expanded'+$filter).show();

				$('.js-no-results').show();
				$('.js-product:visible').each(function(){
					$('.js-no-results').hide();
				});
				if($('.js-product:visible').length){
					$('.js-table-container:visible + .js-undertable').show();
					$('.js-wrap .js-undertable:last-child').last().show();
					// loop through products and show subheads
					$('.js-product:visible').each(function(){
						var shid = $(this).data('subhead');
						$('.js-subhead.'+shid).show();
					});
				}
				
			}else{
				$('.js-table-container').show();
				$('.js-subhead').show();
				$('.js-product').show();
				$('.js-undertable').show();
			}


			$('.js-wrap').fadeTo(200,1);
		});

	}


	// ================================================================================================
	// Toggle FAQs
	// ================================================================================================
	
	// Toggle a question
	$('.question').on('click',function(e){
		e.preventDefault();
		var state = $(this).attr('aria-expanded') === 'false' ? true : false;
		$(this).attr('aria-expanded', state);
		var bg = $(this).data('bg');
		if(typeof(bg) == 'undefined') bg = 'bg-pear';
		console.log(bg);
		$(this).toggleClass(bg+' rounded-t font-bold font-normal bg-grey-lightest rounded');
		$faq = $(this).data('faq');
		$('#'+$faq+' .arrow').toggleClass('ico-arrow-down-black ico-arrow-up-black');
		$('#'+$faq+' .answer').attr('aria-hidden', !state);
		// $('#'+$faq+' .answer').toggleClass('hidden');
		$('#'+$faq+' .answer').slideToggle(); // much nicer!
	});

	// toggle a section
	$('.toggle-faq-section').on('click',function(e){
		e.preventDefault();
		var state = $(this).attr('aria-expanded') === 'false' ? true : false;
		$(this).attr('aria-expanded', state);
		$(this).children().toggleClass('ico-arrow-down-black ico-arrow-up-black');
		$faq_section = $(this).data('faq-section');
		$('#'+$faq_section).attr('aria-hidden', !state);
		$('#'+$faq_section).slideToggle(); 
	});



	// do a smart search
	// $('.faq-search').on('keyup',function(e){
	// 	$searchstring = $('.faq-search').val().toLowerCase();
	// 	var $search = $searchstring.split(' ');		
	// 	$('#search-string').html($searchstring);
	// 	if($searchstring.length > 2){

	// 		$('.hide-on-search').addClass('hidden');
	// 		$('.show-on-search').removeClass('hidden');


	// 		// loop through each search term and see if it's valid
	// 		var $anythingfound = false;
	// 		var $removeterms=[];
	// 		// console.log('search array');
	// 		// console.log($search);
	// 		$($search).each(function(el){
	// 			// console.log('this el:');
	// 			// console.log($search[el]);
	// 			var $found = false;
	// 			var $i = 0;
	// 			$('.faq').each(function(){
	// 				$i++;
	// 				$faq = $(this);
	// 				$keywords = $(this).data('search-terms').toLowerCase();
	// 				if($search[el]!='' && $search[el]!=' ' && $search[el].length > 2){						
	// 					// console.log('looking for- '+$search[el]);
	// 					if($keywords.indexOf($search[el]) != -1){
	// 						// console.log($search[el] + " found");
	// 						$found = true;
	// 						$anythingfound = true;
	// 					}
	// 				}else{
	// 					// console.log('removingx- '+el+' : '+$search[el]);
	// 					// $removeterms[el]=el;						
	// 				}
	// 			});
	// 			if(!$found){
	// 				// console.log('removingy- '+el+' : '+$search[el]);
	// 				$removeterms[el]=el;						
	// 			}
	// 			// console.log('searched '+$i+' faqs');
	// 		});

	// 		// console.log('removing');
	// 		// console.log($removeterms);			

	// 		$($removeterms).each(function(id){
	// 			if($removeterms[id] > -1){
	// 				$search[$removeterms[id]] = "";
	// 			}
	// 		});
	// 		// console.log('now looking for');
	// 		// console.log($search);

	// 		// now loop through each KNOWN search term and show faq lines
	// 		if($anythingfound)
	// 		$($search).each(function(el){
	// 			if($search[el]!='' && $search[el]!=' ')
	// 			$('.faq').each(function(){
	// 				$faq = $(this);
	// 				$($faq).addClass('hidden');
	// 				$keywords = $(this).data('search-terms');
	// 				if($keywords.indexOf($search[el]) != -1){
	// 					$faq.removeClass('hidden');
	// 				}				
	// 			});
	// 		});
			
	// 		$('#noresults').addClass('hidden');
	// 		if(!$anythingfound){
	// 			$('#noresults').removeClass('hidden');
	// 			$('.faq').addClass('hidden');
	// 		}

	// 	}else{
	// 		$('.faq').each(function(){
	// 			$(this).removeClass('hidden');
	// 		});
	// 		$('.hide-on-search').removeClass('hidden');
	// 		$('.show-on-search').addClass('hidden');
	// 	}
	// });
	

	// ================================================================================================
	// FAQs on search page - show more
	// ================================================================================================
	
	$('.faqhidden-show').on('click', function(e){
		e.preventDefault();		
		$('.faqhidden').slideToggle();		
		var $label = $(this).children('.label').html();
		$label = $label=="See more"? "See less" : "See more";
		$(this).children('.label').html($label);
		$(this).children('div').toggleClass('ico-plus');
		$(this).children('div').toggleClass('ico-minus');
		// $('.faqhidden-show-container').slideUp();		
	});
	
	$('.faqhidden-show-new').on('click', function(e){
		e.preventDefault();		
		$('.faqhidden').slideToggle();		
		$(this).slideUp(function(){
			$('.faqhidden-show-new-all').slideDown();		
		});		
	});
	


	// ================================================================================================
	// Apply pop-over
	// ================================================================================================
	
	
	$('#savings_apply').on('click', function(e){
		e.preventDefault();		
		$('#apply_pop_over').fadeIn();		
		$('body').addClass('modal-open');
	});
	// $('#apply_pop_over')

	$('#apply_pop_over_close').on('click',function(e){
		e.preventDefault();		
		$('#apply_pop_over').fadeOut();
		$('body').removeClass('modal-open');
	});

	// $('#apply_pop_over_go').on('click',function(e){
	// 	e.preventDefault();
	// 	top.location.href($('#savings_apply').prop('href'));
	// });


	// ================================================================================================
	// Tooltip click
	// ================================================================================================
		//$('body').on('click','[data-tooltip]', function(e){ e.preventDefault() ; return false;});

	// ================================================================================================
	// site-wide alert
	// ================================================================================================
	var site_wide_id = $('.hide-site-wide').prop('id');
	console.log('site_wide_id'+site_wide_id);
	$('.hide-site-wide').on('click',function(e){
		e.preventDefault();
		$('#site_wide_alert').slideUp();
		setCookie('hide_site_wide_message', site_wide_id); 
	});

	if (getCookie('hide_site_wide_message') != site_wide_id){	
		if(typeof($('#site_wide_alert'))!="undefined"){
			$('#site_wide_alert').slideDown();
		}
	}


	// ================================================================================================
	function setCookie (name, value, expires, path, domain, secure) {
		document.cookie = name + "=" + escape(value) +
		((expires) ? "; expires=" + expires : "") +
		((path) ? "; path=" + path : "") +
		((domain) ? "; domain=" + domain : "") +
		((secure) ? "; secure" : "");
	}
	// ================================================================================================
	function getCookie (name) {
		var cookie = " " + document.cookie;
		var search = " " + name + "=";
		var setStr = null;
		var offset = 0;
		var end = 0;
		if (cookie.length > 0) {
			offset = cookie.indexOf(search);
			if (offset != -1) {
				offset += search.length;
				end = cookie.indexOf(";", offset);
				if (end == -1) {
					end = cookie.length;
				}
				setStr = unescape(cookie.substring(offset, end));
			}
		}
		if (setStr == 'false') {
			setStr = false;
		} 
		if (setStr == 'true') {
			setStr = true;
		}
		if (setStr == 'null') {
			setStr = null;
		}
		return(setStr);
	}	

	// ================================================================================================
	// Add cookie settings button
	// ================================================================================================
	$(document).ready(function(){
		$('a[href="#cookiesettings"]').click(function(){
			window.cc.showSettings();
		});
	});


	// ================================================================================================
	// Media download
	// ================================================================================================
	
	// if ( typeof(window.p) != "undefined" ){
	// 	var cookie = getCookie('gatehouseMediaLibrary');
	// 	if(md5(md5(window.p)) == cookie){
	// 		console.log('match');
	// 	}
	// }
	$('.ban-download').on('click',function(e){
		e.preventDefault();
		
		window.mediaItem = $(this);

		if(go_media_check(window.mediaItem)){
		}else{
			// show the login window
			$('#media_pop_over').fadeIn();
		}
		return false;
	});

	// setCookie ('gatehouseMediaLibrary', '');
	// mediapasswordform
	// mediapassword

	$('#media_pop_over_close').on('click',function(e){
		e.preventDefault();		
		$('#media_pop_over').fadeOut();
	});

	$('#mediapasswordform').on('submit',function(e){
		e.preventDefault();		
		$('.wrongpassword').fadeOut();
		setCookie ('gatehouseMediaLibrary', md5(md5($('#mediapassword').val())));		
		if(go_media_check(window.mediaItem)){
			$('#media_pop_over').fadeOut();
		}else{
			$('.wrongpassword').fadeIn();
		}
	});

	function go_media_check(item){
		console.log(item);
		var cookie = getCookie('gatehouseMediaLibrary');
		console.log(cookie);
		if(md5(window.p) == cookie){
			console.log('match');
			var url = $(item).data('location').replace('/xmedia/','/images/media/');
			window.open(url);
			return true;
		}
		return false;
	}

	
	// ================================================================================================
	// Autocomplete
	// ================================================================================================
	
	function do_lookahead(){
		var $search = $('#q').val().replace(/-/g, ' ');
		if($search.length>2){ // only search on the 3rd character
			$('#predict').show();
			var $matches = 0;
			// loop through links
			$('#predict li.predict-item').each(function(e){
				var $str = $(this).data('title');
				$(this).removeClass('hidden');
				if ($str.toLowerCase().replace(/-/g, ' ').search(new RegExp($search, "i")) == -1) {
					$(this).addClass('hidden');
				}else{
					$matches++;
					var $pos = $str.toLowerCase().replace(/-/g, ' ').indexOf($search.toLowerCase());
					var $highlight = $str.substr(0, $pos) + '<strong class="font-semibold">' + $str.substr($pos, $search.length) +'</strong>' + $str.substr($pos+$search.length) ;
					$(this).children('a').html($highlight);
				}					
			});	
			if(!$matches) $('#predict').hide();
		}else{
			$('#predict').hide();
		}
	}

	if ($('#predict').length) {
		$('#q').on('keyup',function(e){
			do_lookahead();
		});
		$('body').on('click',function(){
			if(!$('#q').is(":focus")) $('#predict').hide();
		});
		$('body').on('focus','#q',function(){
			do_lookahead();
		});
	}

	// ================================================================================================
	// Quck postcode lookup
	// ================================================================================================

	function do_postcodelookahead($section){
		var $postcode = $('.postcodepredict',$section).val().toLowerCase();
		var matches = 0;
		if($postcode.length > 1 || /\d/.test($postcode) ){ // only search on the 2nd character unless the character is a number
			// loop through links
			var number_index = $postcode.search(/\d/);
			var $letters = number_index > 0 ? $postcode.substring(0, number_index) : $postcode;

			$('.bio-outer:not([data-areas=all])',$section).each(function(e){
				var $areas = $(this).data('areas').toLowerCase().split(',');
				$(this).removeClass('hidden');
				if (!$areas.includes($letters.toLowerCase())) {
					$(this).addClass('hidden');
				} else {
					matches++;
				}
			});	

			if (matches === 0 && $('.bio-outer[data-areas=all]',$section).length == 0) {
				$('.no_team_members',$section).removeClass('hidden');
			} else {
				$('.no_team_members',$section).addClass('hidden');
			}
		} else {
			$('.bio-outer',$section).removeClass('hidden');
			$('.no_team_members',$section).addClass('hidden');
		}
	}

	if ($('.postcodepredict').length) {

		$('.postcodepredict').each( function() {
			var $section = $(this).closest('section');

			$('.postcodepredict',$section).on('keyup',function(e){
				do_postcodelookahead($section);
				if($('.postcodepredict',$section).val().length>1){
					$('.resultstitle',$section).show();
				}else{
					$('.resultstitle',$section).hide();	
				}
				if($('.postcodepredict',$section).val().length>0){
					$('.postcodepredict',$section).siblings('.clear-search').removeClass('hidden');
				}else{
					$('.postcodepredict',$section).siblings('.clear-search').addClass('hidden');			
				}
			});

			$('body').on('click',function(){
				if(!$('.postcodepredict', $section).is(":focus")) $('.predict',$section).hide();
			});

			$('body').on('focus','.postcodepredict',function(){
				do_postcodelookahead($section);
			});
		});

	}


	// ================================================================================================
	// RANDOMISE BULLETS
	// ================================================================================================
	
	var uls = document.querySelectorAll('ul.random'), n;
	for (n = 0; n < uls.length; ++n) {
		for (var i = uls[n].children.length; i >= 0; i--) {
			uls[n].appendChild(uls[n].children[Math.random() * i | 0]);
		}
	}


	// ================================================================================================
	// Smooth Scrolling
	// ================================================================================================
	
	if ($.fn.smoothScroll) {
		$('a.smooth').smoothScroll();
	}

	// ================================================================================================
	// Cookie button - add attr
	// ================================================================================================
	

	//$('').addAttr('');
});


// ================================================================================================
// VIDEO THUMBNAIL SETTINGS
// ================================================================================================
	
function vimeoLoadingThumb(id){    
	var url = "https://vimeo.com/api/v2/video/" + id + ".json?callback=showVimeoThumb";

	var id_img = "#vimeo-" + id;

	var script = document.createElement( 'script' );
	script.src = url;

	// console.log(url);
	// /console.log(script.src);

	$(id_img).before(script);
}

function showVimeoThumb(data){
	var id_img = "#vimeo-" + data[0].id;
	$(id_img).css('background-image','url("'+data[0].thumbnail_large+'")');
	// $(id_img).css('background','blue');
}
